<style lang="less">
  // @import '../flow.less';
  @import '../flow/base.less';
</style>
<template>
    <Tabs value="project">
        <TabPane label="基本信息" name="project">
          <ProjectForm :handleSubmit="this.handleEditorSubmit" type="editor" :data="data" />
        </TabPane>
        <TabPane label="代码信息" name="code">
          <CodeForm  type="editor" :id="data.id" />
        </TabPane>
        <TabPane label="开发环境" name="develop">
          <DeploymentForm scenes='develop' :id="data.id" />
        </TabPane>
        <TabPane label="测试环境" name="test">
          <DeploymentForm scenes='test' :id="data.id" />
        </TabPane>
        <TabPane label="生产环境" name="product">
          <DeploymentForm scenes='product' :id="data.id" />
        </TabPane>
    </Tabs>
</template>
<script>
import { getProjectDetail, ProjectBaseInfoSubmit } from '@/api/project'
import ProjectForm from './ProjectForm'
import CodeForm from './CodeForm'
import DeploymentForm from './DeploymentForm'
export default {
  name: 'ProjectDetail',
  components: {
    'ProjectForm': ProjectForm,
    'CodeForm': CodeForm,
    'DeploymentForm': DeploymentForm
  },
  data () {
    return {
      data: {}
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.getProjectDetail(this.$route.query.id)
      }
    }
  },
  methods: {
    getProjectDetail (id) {
      let params = {
        id: id
      }
      getProjectDetail(params).then(res => {
        this.data = res.data
      })
    },
    // submit project 基本信息表单
    handleEditorSubmit (values) {
      ProjectBaseInfoSubmit(this.$route.query.id, values).then(res => {
        if (res.data.id > 0) {
          this.$router.push({name: 'ProjectDetail', query: {id: res.data.id}})
        } else {
          this.$Message.error(res.data)
        }
      })
    }
  },
  mounted: function () {
    this.getProjectDetail(this.$route.query.id)
  }
}
</script>
